import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { hostCommandCancelFailed, hostCommandCancelSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* hostCommandCancel(action) {
  try {
    const id = action.payload;
    const url = `${BACKEND_URL}/host-commands/cancel`;
    const pool = {
      host_command_ids: [id],
    };
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK && responseJson) {
      yield put(hostCommandCancelSuccessful(responseJson));
      yield call(resolveActionPromise(action, responseJson));
    } else {
      yield put(hostCommandCancelFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(hostCommandCancelFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
